import { render, staticRenderFns } from "./magyloterry.vue?vue&type=template&id=8a134cb6&"
import script from "./magyloterry.vue?vue&type=script&lang=js&"
export * from "./magyloterry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports